module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hres4ax-detail",
    attrs: {
      "name": "hres4ax-detail"
    }
  }, [_c('div', {
    staticClass: "btn-zoom"
  }, [_c('div', [_c('i', {
    staticClass: "item fa fa-search-plus",
    on: {
      "click": function($event) {
        _vm.zoom('+')
      }
    }
  })]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "item fa fa-search-minus",
    on: {
      "click": function($event) {
        _vm.zoom('-')
      }
    }
  })]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "item fa fa-search",
    on: {
      "click": function($event) {
        _vm.scale = 100
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "scale"
  }, [_vm._v(_vm._s(_vm.scale + '%'))])]), _vm._v(" "), _c('orgchart', {
    style: ('zoom: ' + this.scale + '%;'),
    attrs: {
      "data": _vm.detail,
      "labels": _vm.labels,
      "receivedOrgBodyDetail": _vm.receivedOrgBodyDetail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fe061b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres4ax/detail.vue
// module id = 3812
// module chunks = 1